import React, { useState } from 'react';
import { signOut } from 'aws-amplify/auth';
import { useNavigate, Link } from 'react-router-dom';
import './Header.css';

const Header = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut();
      // Clear user from state
      setUser(null);
      // Navigate to home page
      navigate('/');
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="logo" onClick={() => navigate('/')}>NIGHT BACON</div>
      
      {/* Mobile menu button */}
      <button className="mobile-menu-button" onClick={toggleMenu}>
        {menuOpen ? '✕' : '☰'}
      </button>
      
      <nav className={`nav-links ${menuOpen ? 'active' : ''}`}>
        {user ? (
          <>
            <Link to="/files" onClick={() => setMenuOpen(false)}>Files</Link>
            <Link to="/calendar" onClick={() => setMenuOpen(false)}>Calendar</Link>
            <Link to="/playlists" onClick={() => setMenuOpen(false)}>Playlists</Link>
            <Link to="/videos" onClick={() => setMenuOpen(false)}>Videos</Link>
            <Link to="/lyrics" onClick={() => setMenuOpen(false)}>Lyrics</Link>
            <button onClick={() => {
              handleSignOut();
              setMenuOpen(false);
            }}>Sign Out</button>
          </>
        ) : (
          <Link to="/login" onClick={() => setMenuOpen(false)}>Login</Link>
        )}
      </nav>
    </header>
  );
};

export default Header;
